export const parseField = (field, type = "default") => {
  const strValue = field !== null && field !== undefined ? String(field) : "0";
  const cleanValue = strValue.replace(/,/g, '');
  const numericValue = isNaN(cleanValue) ? 0 : parseFloat(cleanValue);

  switch(type) {
    case "integer":
      return Math.round(numericValue).toString();
    case "money":
      if (numericValue >= 1000) {
        return (numericValue / 1000).toFixed(1) + "K";
      } else {
        return numericValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    case "full-money":
      return numericValue.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    case "percentage":
      return numericValue.toFixed(2);
    case "default":
    default:
      return strValue;
  }
};